<template>
  <div class="collector-stat-list-holder" id="herd-stats">
    <h3 class="collector-stat-list-heading elr-heading-shortline">Your Collection Stats:</h3>
    <div class="collector-stat-list" v-if="herdStats && herdStats.length">
      <Stat :key="stat.itemClass" :stat="stat" v-for="stat in herdStats" />
    </div>
  </div>
</template>

<script>
import Stat from '../Stat/Stat';

export default {
  name: 'HerdStats',
  props: {
    herdStats: {
      type: Array,
      required: true
    }
  },
  components: {
    Stat
  }
};
</script>

<style scoped lang='scss'>

@import '../../assets/sass/config';

.collector-stat-list-holder {
  max-width: $max-width;
  margin: auto;
  padding: 20px 0 40px;

  @media (max-width: 568px) {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

.collector-stat-list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 20px 10px 0;

  @media (max-width: 568px) {
    padding-top: 10px;
  }
}

.collector-stat-list-heading {
  color: $accent-color;
  font-weight: 900;

  @media (max-width: 568px) {
    padding-bottom: 5px;
  }
}
</style>
